import { DodajPoleSpisuModel } from "./dodajPoleSpisuModel";

export class EdytujPoleSpisuModel extends DodajPoleSpisuModel {
    id: string;
}